import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryBoxComponent } from './history-box.component';
import { HistoryBoxRoutingModule } from './history-box-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'ng-select';
import { BsDatepickerModule, ModalModule, TooltipModule } from 'ngx-bootstrap';
import { BoxStampDistributionComponent } from '../share/boxStampDistribution/boxStampDistribution.component';
import { BoxRetalStampsModule } from '../share/boxRetalStamps/boxRetalStamps.module';
import { FilterProductsModule } from '../../../../layout/filter-products/filter-products.module';
import { Select2ApiModule } from '../share/select2Api/select2Api.module';
import { EditProductRoadmapModalComponent } from '../productRoadmap/editProductRoadmapModal/editProductRoadmapModal.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    HistoryBoxRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,
    BoxRetalStampsModule,
    FilterProductsModule,
    Select2ApiModule,
    ModalModule,
    TranslateModule,
  ],
  exports: [BoxStampDistributionComponent, EditProductRoadmapModalComponent],
  declarations: [HistoryBoxComponent, BoxStampDistributionComponent, EditProductRoadmapModalComponent],
})
export class HistoryBoxModule {
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/history-box/history-box.module.ts